<template>
  <div class="settlement">
    <EsHeaderView />
    <div class="settlement-content app-container" v-loading="loading"   >
      <h1 class="title">{{ $t("message.home.checkout") }}</h1>

      <!-- 游客快速结账：未登录且开启游客下单时显示 GuestCheckout 表单 -->
      <template v-if="!isLogin && guestCheckoutEnabled">
        <GuestCheckout @success="onGuestSuccess" @needLogin="onGuestNeedLogin" />
      </template>

      <!-- 已登录用户正常流程 -->
      <template v-else-if="isLogin">
      <h2 class="subtitle">{{ $t("message.home.shippingAddress") }}</h2>
      <div class="settlement-receiver flex-between" @click="selectAddressEvent">
        <div>
          <div class="userinfo">
            <span v-if="defaultAddress && defaultAddress.phone">
              {{ defaultAddress.consignee }} +{{ defaultAddress.phone }}
            </span>
          </div>
          <p class="address" v-if="defaultAddress && defaultAddress.address">
            {{ defaultAddress.regionName }}{{ defaultAddress.address }}
          </p>
        </div>
        <div><i class="el-icon-arrow-right"></i></div>
      </div>
      <!----------------------------------------------------------------------------------------------------->


      <div class="settlement"  >
        <div class="settlement-commodity" v-for="(item, index) in obj.orders" :key="index">
          <!-- {{ checkProductPay }} -->
          <!-- <el-checkbox class="settlement-commodity-title" v-model="item.checkAll" :indeterminate="item.isIndeterminate"
            @change="handleCheckAllChange($event, index)">
            {{ item.list[0].seller.name }}（{{ $t("message.home.totalOf") }}
            {{ item.checkList.length }} {{ $t("message.home.items") }}）
          </el-checkbox> -->
          <div class="settlement-commodity-title">
            {{ item.storeName }}
            <!-- {{ item.checkList.length }} {{ $t("message.home.items") }}） -->
          </div>
          <div class="settlement-commodity-group">
            <div class="settlement-commodity-wrap" v-for="(items, index2) in item.orderItems" :key="index2">
              <!-- <el-checkbox :label="items.id" class="settlement-commodity-checkbox flex-between"> -->
              <div class="settlement-commodity-item flex-start">
                <img :src="items.thumbnail" alt="" />
                <div class="flex-start settlement-commodity-info"
                  :style="{ flexDirection: 'column', alignItems: 'flex-start' }">
                  <div>
                    <h2 :title="items.name">{{ items.name }}</h2>
                    <p>
                      {{ priceFmt(items.price) }}
                    </p>
                    <!-- <p v-else>
                          ${{
                            childItem.discountPrice ?? childItem.sellingPrice
                          }}
                        </p> -->
                  </div>
                  <div class="settlement-commodity-info-attr"
                    v-if="items.specifications && items.specifications.length > 0">
                    <span>{{ $t("message.home.orderSpecification") }}:</span>
                    <span><span style="margin-left: 30rpx;"
                        v-if="items.specifications && items.specifications.length > 0">[</span><span
                        v-for="(it, idx) in items.specifications" :key="idx">{{ " " + it + " " }}</span><span
                        v-if="items.specifications && items.specifications.length > 0">]</span></span>
                  </div>
                </div>
              </div>
              <!-- </el-checkbox> -->
              <div style="width: 100px;position: absolute;top: 30px;right: 24px;">x {{ items.quantity }}</div>
              <!-- <el-input-number v-model="item.quantity" size="mini" key="item.quantity"
                  @blur="changeNum(childItem, event)" :precision="0"  /> -->
            </div>
          </div>
        </div>
      </div>


      <!----------------------------------------------------------------------------------------------------->
      <!-- <EsOrderList /> -->

      <!----------------------------------------------------------------------------------------------------->

      <div class="order-sum">
        <h1>{{ $t("message.home.orderSummary") }}</h1>
        <ul class="order-sum-content">
          <!-- <li
        v-for="(item, index) in orderSum"
        :key="index"
        :class="{ total: index === orderSum.length - 1, 'flex-between': true }"
      >
        <span>{{ item.name }}</span>
        <span> {{ item.value }} </span>
      </li> -->

          <li class="flex-between">
            <span>{{ $t('message.home.商品合计金额') }}</span>
            <span>{{ priceFmt(obj.price || 0) }}</span>
          </li>

          <li class="total flex-between">
            <span>{{ $t('message.home.运费') }}</span>
            <span>{{ priceFmt(obj.freight || 0) }}</span>
          </li>
          <li class="total flex-between">
            <span>{{ $t('message.home.赠送积分') }}</span>
            <span>{{ obj.rewardPoint || '0' }}</span>
          </li>
          <li class="total flex-between">
            <span>{{ $t('message.home.促销折扣') }}</span>
            <span>{{ priceFmt(obj.marketingDiscount || 0) }}</span>
          </li>
          <li class="total flex-between">
            <span>{{ $t('message.home.优惠券折扣') }}</span>
            <span>{{ priceFmt(obj.couponDiscount || 0) }}</span>
          </li>
          <li v-if="formData.balance > 0" class="total flex-between">
            <span>{{ $t('message.home.depositDeduct') }}</span>
            <span>-{{ priceFmt(formData.balance) }}</span>
          </li>
          <li v-if="obj.deductionAmount > 0" class="total flex-between">
            <span>{{ $t('message.home.积分抵现') }}</span>
            <span>-{{ priceFmt(obj.deductionAmount) }}</span>
          </li>

        </ul>
      </div>

      <!----------------------------------------------------------------------------------------------------->
      <!-- <EsOrderSum :checkGoods="chcekData" /> -->

      <!----------------------------------------------------------------------------------------------------->

      <div v-if="showDepositSection" class="pay-method deposit-pay">
        <h1>{{ $t('message.home.useDepositBalance') }}</h1>
        <ul class="pay-method-content">
          <li class="pay-method-item flex-between">
            <div class="pay-method-item-left flex-start">
              <p class="name">
                <span>{{ $t('message.home.availableBalance') }}</span>
                <span class="amount">{{ priceFmt(availableBalance) }}</span>
              </p>
            </div>
            <el-switch v-model="useDepositBalance" @change="onDepositToggle"></el-switch>
          </li>
          <li v-if="useDepositBalance" class="pay-method-item flex-between deposit-input-row">
            <div class="pay-method-item-left flex-start">
              <span class="deposit-label">{{ $t('message.home.depositDeduct') }}</span>
              <el-input-number
                v-model="balanceInput"
                :min="0"
                :max="maxDepositAmount"
                :precision="2"
                :step="0.01"
                size="small"
                @change="onBalanceChange"
              ></el-input-number>
              <el-button type="text" class="deposit-max-btn" @click="applyMaxDeposit">
                {{ $t('message.home.useMaxDeposit') }}
              </el-button>
            </div>
          </li>
        </ul>
      </div>

      <div class="pay-method point-deduct-pay">
        <h1>{{ $t('message.home.积分抵现') }}</h1>
        <ul class="pay-method-content">
          <li class="pay-method-item flex-between deposit-input-row">
            <div class="pay-method-item-left flex-start">
              <span class="deposit-label">{{ $t('message.home.使用积分抵扣') }}</span>
              <el-input-number
                v-model="formData.usePoint"
                :min="0"
                :step="100"
                size="small"
                @change="onUsePointChange"
              ></el-input-number>
              <span v-if="obj.deductionAmount > 0" class="deposit-label" style="margin-left:10px">
                -{{ priceFmt(obj.deductionAmount) }}
              </span>
            </div>
          </li>
        </ul>
      </div>

      <div v-if="showPaymentMethods" class="pay-method">
        <h1 v-if="showTitle">{{ $t('message.home.paymentMethod') }}</h1>
        <ul class="pay-method-content">
          <!-- <li class="pay-method-item flex-between">
            <div class="pay-method-item-left flex-start">
              <img :src="require('@/assets/image/Union.png')" alt="" />
              <p class="name">
                <span>{{ $t('message.home.Balance') }}</span>
                (
                <span class="amount">${{obj.amountPayable||'0'}}</span>
                )
              </p>
            </div>
            <el-radio  :label="1"></el-radio>
          </li> -->
          <li class="pay-method-item flex-between">
            <div class="pay-method-item-left flex-start">
              <img :src="require('@/assets/image/Union.png')" alt="" />
              <p class="name">
                <span>Biz System</span>
                <span class="amount"></span>
              </p>
            </div>
            <el-radio v-model="paymentMethodRadio" label="bizSystem"></el-radio>
          </li>
          <li class="pay-method-item flex-between">
            <div class="pay-method-item-left flex-start">
              <img :src="require('@/assets/image/paypal.png')" alt="" style="height: 28px;" />
              <p class="name">
                <span>{{ $t('message.home.payPal') }}</span>
              </p>
            </div>
            <el-radio v-model="paymentMethodRadio" label="paypalPayment"></el-radio>
          </li>
          <li class="pay-method-item flex-between">
            <div class="pay-method-item-left flex-start">
              <img :src="require('@/assets/image/stripe.svg')" alt="" style="height: 28px;" />
              <p class="name">
                <span>Stripe</span>
              </p>
            </div>
            <el-radio v-model="paymentMethodRadio" label="stripePayment"></el-radio>
          </li>



          <!-- <li class="pay-method-item flex-between">
            <div class="pay-method-item-left flex-start">
              <img :src="require('@/assets/image/visa.png')" alt="" />
              <p class="name">
                <span>Visa</span>
              </p>
            </div>
            <el-radio  v-model="radio" :label="3" ></el-radio>
          </li>
          <li class="pay-method-item flex-between">
            <div class="pay-method-item-left flex-start">
              <img :src="require('@/assets/image/master.png')" alt="" />
              <p class="name">
                <span>{{ $t('message.home.mastercard') }}</span>
              </p>
            </div>
            <el-radio  v-model="radio" :label="4" ></el-radio>
          </li> -->
        </ul>
      </div>

      <!----------------------------------------------------------------------------------------------------->
      <!-- <EsPayMethod /> -->

      <!-- Stripe 支付表单容器 -->
      <div v-show="showPaymentMethods && paymentMethodRadio === 'stripePayment'" class="stripe-container" style="margin: 20px 0;">
        <div id="stripe-payment-element" style="margin-bottom: 16px;"></div>
        <el-button v-if="stripeReady" type="primary" :loading="stripeLoading" @click="handleStripePay" style="width: 100%;">
          {{ $t('message.home.subOrder') }}
        </el-button>
      </div>

      <div class="settlement-pay flex-between">
        <div class="settlement-pay-label">
          <!-- {{ $t("message.home.Opt") }}
          <span>{{ checkNum }}</span>
          {{ $t("message.home.piece") }} -->
        </div>
        <el-button type="primary"  @click="formSubmit">
          <span>{{ $t("message.home.subOrder") }}</span>
          <span>{{ priceFmt(displayAmount) }}</span>
        </el-button>
      </div>
      <EsIconTips />
      </template><!-- end v-else (已登录) -->
    </div>
    <EsFooterView />

    <!-- <EsPayModal   :payCallback="payCallback"  @changeShowModel="changeShowModel"  /> -->

    <!-- PayPal 支付弹框 -->
    <el-dialog :visible.sync="paypalDialogVisible" class="es-dialog" :append-to-body="true" width="500px" :close-on-click-modal="false" @close="onPaypalDialogClose">
      <div slot="title" class="dialog-title">
        <span>{{ $t('message.home.payPal') }}</span>
      </div>
      <div class="pay-modal-content" style="padding: 20px 30px;">
        <h3 style="text-align: center; margin-bottom: 24px; color: var(--color-price); font-size: 20px;">
          {{ priceFmt(displayAmount) }}
        </h3>
        <div id="paypal-button-container"></div>
        <div id="paypal-card-button-container" style="margin-top: 12px;"></div>
      </div>
      <span slot="footer"></span>
    </el-dialog>

    <template>
      <el-dialog :visible.sync="payModalShow" class="es-dialog" :append-to-body="true" width="475px">
        <div slot="title" class="dialog-title">
          <span v-if="showModel === 0">{{ $t('message.home.确认') }}</span>
          <span v-if="showModel === 1">{{ $t('message.home.setUpPayPaw') }}</span>
          <span v-if="showModel === 2">{{ $t('message.home.confirmPayPaw') }}</span>
        </div>
        <div class="pay-modal-content dialog-content">
          <h2 style="width: 100% ;line-height: 120px;text-align: center;" class="pay-modal-title">{{ $t('message.home.确定支付订单？') }}</h2>
          <!-- <h2 class="pay-modal-title" v-if="showModel === 2">
            {{ $t('message.home.desc6') }}
          </h2> -->
          <!-- <EsPayPassword ref="passwordRef" :type="'password'" :maxlength="6" /> -->
          <div class="pay-modal-btn">
            <el-button type="primary" :loading="loading" @click="payment_outLinePay" v-if="showModel === 0">
              {{ $t('message.home.确认') }}
            </el-button>
            <!-- <el-button type="primary" :loading="loading" @click="setUpPaw" v-if="showModel === 1">
              {{ $t('message.home.确认') }}
            </el-button> -->
            <!-- <div v-if="showModel === 2" class="pay-button-view">
              <el-button :loading="loading" @click="previous">
                {{ $t('message.home.previous') }}
              </el-button>
              <el-button type="primary" :loading="loading" @click="confirmPayPaw">
                {{ $t('message.home.确认') }}
              </el-button>
            </div> -->
          </div>
        </div>
        <span slot="footer"></span>
      </el-dialog>
    </template>


    <!---------------------------------------------------------------------------------------------------->


    <el-dialog class="es-dialog" :visible.sync="dialogVisible" :center="true" :append-to-body="true" width="600px">
      <div slot="title" class="dialog-title">
        <span>{{ $t('message.home.selectDeliveryAddress') }}</span>
      </div>
      <div class="address-modal-content dialog-content">
        <div :class="{
          'address-active': paySelectAddress.id === item.id,
          item: true,
        }" v-for="item in addressList" :key="item.id">
          <div class="info">
            <span class="name">{{ item.contacts }}</span>
            <span class="mobile">&nbsp;&nbsp;+{{ item.phone }}</span>
          </div>
          <div class="address">
            {{ item.country }} {{ item.province }} {{ item.city }}
            {{ item.address }}
          </div>
        </div>
        <div class="item">
          {{ $t('message.home.addNewAddress') }}
        </div>
      </div>
      <span slot="footer"></span>
    </el-dialog>


    <!---------------------------------------------------------------------------------------------------->


    <AddressDialog v-model="addAddressModalShow" @showAddAddressView="showAddAddressView" />
    <EsAddAddress v-model="addAddressView" @parent-refresh="onAddressSaved" />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import EsIconTips from "@/components/iconTips";
// import EsOrderSum from "./orderSum.vue";
// import EsOrderList from "./orderList.vue";
// import EsPayMethod from "./payMethod.vue";
// import EsPayModal from "./payModal.vue";
import AddressDialog from "./address";
import { setCartItemsLocal, getCartItemsLocal } from "@/util/shop";
import { formatCurrency } from "@/util";
import EsAddAddress from "@/components/addAddress";
import EsPayPassword from "@/components/payPassword";
import GuestCheckout from "@/components/GuestCheckout";
import { getGuestCart, clearGuestCart } from "@/util/guestCart";
import { getGuestCheckoutEnabled } from "@/api/upms/guest";
import { add as cartAdd } from "@/api/order/cart.js";


//////////////////////////////////////////////////////////////////////////////////////////////////

import {
  check_coupon,
  address_list,
  payment,
  calculate,
  create,
  add_address,
  checkout
} from "@/api/order/order.js"
import { exchange_list } from "@/api/goods/goods"
import {
  load,
  testPostPay,
  index as paymentIndex,
  pay as paymentPay,
  postPay,
  is_pay_success,
} from "@/api/order/payment.js"

//////////////////////////////////////////////////////////////////////////////////////////////////

export default {
  name: "EsSettlement",
  components: {
    EsIconTips,
    // EsOrderSum,
    // EsOrderList,
    // EsPayMethod,
    // EsPayModal,
    AddressDialog,
    EsAddAddress,
    GuestCheckout,
    // EsPayPassword,
  },
  data() {
    return {

      guestCheckoutEnabled: null,
      payModalShow: false,
      addAddressModalShow: false,
      selectAddress: {},
      currentSubmitOrderIds: [],
      addAddressView: false,
      chcekData: [],
      checkNum: 0,
      lastSubmit: {
        orderIds: "",
        addressId: "",
        orderInfo: {},
      },

      orderSum: [
        {
          name:
            this.$t("message.home.commodity") + this.$t("message.home.amount"),
          value: `$0`,
        },
        {
          name: this.$t("message.home.discount"),
          value: "-$0.00",
        },
        {
          name: this.$t("message.home.tax"),
          value: "+$0.00",
        },
        {
          name: this.$t("message.home.deliveryFee"),
          value: "+$0.00",
        },

        {
          name: this.$t("message.home.totalNum"),
          value: `$22`,
        },
      ],

      showTitle: true,
      dialogVisible: false,
      loading: false,

      //////////////////////////////////////////////////////////////////////////////////////////////////

      paymentMethodRadio: 'bizSystem',

      orderBy: "",
      //排序 asc正 desc反
      searchLoading: false,
      //"上拉加载"的变量，默认false，隐藏  
      searchLoadingComplete: false,
      //“没有数据”的变量，默认false，隐藏 

      total: 0,
      goods: [],
      goodsId: "",
      index: 0,
      userInfo: {},
      orderInfo: {},
      loadingHidden: false,
      carts: [],
      showcartlist: false,
      is_check: false,
      invoiceShow: false,
      addressId: "",
      ogoodsId: "",
      ototal: 0,
      buyFlag: 1, //1购物车购买  2 直接购买



      obj: {
        amount: null,
        amountPayable: null,
        couponDiscount: null,
        exchangePoint: null,
        fee: null,
        freight: null,
        isDelivery: null,
        price: null,
        marketingDiscount: null,
        rewardPoint: null,
        tax: null,
        deductionAmount: 0,
        orders: []
      },
      objsList: [],
      skuId: null,
      marketingId: null,
      skuQuantity: 0,
      paymentPatterns: [],
      shippingMethods: [],
      coupons: [],
      defaultAddress: {},
      indexPM: 0,
      indexSM: 0,
      indexCC: 0,
      formData: {
        skuId: null, //直接购买  skuId
        marketingId: null,
        notJoinGroup: false,
        quantity: 0, //直接购买  数量
        addressId: null, //地址
        paymentPatternId: null, //支付方式
        shippingMethodId: null, //配送方式
        code: null, //优惠码
        invoiceTitle: null, //发票 白头
        invoiceTaxNumber: null, //税号
        invoiceContent: null, //发票内容
        balance: 0, //余额
        remark: null, //备注
        currentCartId: null, //购物车
        usePoint: 0, //积分抵现使用积分
      },
      notJoinGroup: false,
      orders: [],
      orderSns: null,
      orderType: null,

      password: '',
      // 0 支付界面 1 设置支付密码 2 确认支付密码
      showModel: 0,


      totalPrice: 0,
      paymentItemListForm: {
        paymentItemList: []
      }, //支付项
      online: null,
      defaultPayment: null,
      payments: null,
      shippingMethodName: null,
      paymentPatternName: null,
      paymentPattern: null,
      expireDate: null,
      paymentLog: null,
      payPalOrderInfo: {},
      num: 0.01,

      // PayPal & Stripe
      paypalSDKLoaded: false,
      paypalSDKCurrency: '',
      paypalButtonsRendered: false,
      paypalDialogVisible: false,
      stripeInstance: null,
      stripeElements: null,
      stripeReady: false,
      stripeLoading: false,
      stripePaymentLogSn: null,

      availableBalance: 0,
      useDepositBalance: false,
      balanceInput: 0,

      //////////////////////////////////////////////////////////////////////////////////////////////////
    };
  },
  computed: {
    ...mapGetters({
      addressList: "user/addressList",
      // defaultAddress: "user/defaultAddress",
      paySelectAddress: "user/paySelectAddress",
      checkProductPay: "cart/checkProductPay",
      userBalance: "user/userBalance",
      currentCart: "currentCart",
      isLogin: "isLogin",
      // userInfo: "userInfo",
    }),
    checkCount() {
      // return null;
      return this.checkProductPay.reduce(
        (a, b) => a + b.list.reduce((i, l) => i + l.checkTotal, 0),
        0
      );
    },
    checkTotalAmount() {
      return this.getChcekData().reduce(
        (a, b) =>
          a +
          ((b.price || b.discountPrice || b.sellingPrice) +
            (b.goodsTax ?? 0) +
            (b.freightAmount ?? 0)) *
          b.checkTotal,
        0
      )
    },
    isDisabledPayBtn() {
      return (
        this.userBalance <= 0 ||
        this.checkCount <= 0 ||
        this.userBalance < this.checkTotalAmount
      );
    },
    displayAmount() {
      const o = this.obj || {};
      const payable = this.parseAmount(o.amountPayable);
      if (payable >= 0 && (o.amountPayable !== null && o.amountPayable !== undefined && o.amountPayable !== '')) {
        return payable;
      }
      const pick = (v) => (v !== null && v !== undefined && v !== '' && Number(v) > 0) ? v : null;
      let val = pick(o.amount) || pick(o.price);
      if (!val && Array.isArray(o.orders) && o.orders.length) {
        const sum = o.orders.reduce((s, ord) => s + Number(ord.amount || ord.amountPayable || ord.price || 0), 0);
        if (sum > 0) val = sum;
      }
      if (!val) val = pick(this.totalPrice);
      return val != null ? val : '0';
    },
    showDepositSection() {
      return this.orderType !== 'EXCHANGE' && this.parseAmount(this.availableBalance) > 0;
    },
    showPaymentMethods() {
      return this.parseAmount(this.obj && this.obj.amountPayable) > 0;
    },
    maxDepositAmount() {
      return Math.min(this.parseAmount(this.availableBalance), this.getOrderAmountBeforeDeposit());
    },
    // checkProduct() {
    //     return this.getChcekData();
    // }
  },
  watch: {
    paySelectAddress: {
      handler(val) {
        if (val && val.id) {
          this.applySelectedAddress(val);
        }
      },
      deep: true,
    },
    addAddressView(val, oldVal) {
      if (oldVal && !val) {
        this.onAddressSaved();
      }
    },
  },
  async mounted() {
    // 已登录用户走正常结算流程，无需等待游客结账开关接口，避免多一次串行请求
    if (this.isLogin) {
      await this.checkout_init();
      return;
    }
    try {
      const res = await getGuestCheckoutEnabled();
      this.guestCheckoutEnabled = res && res.data && res.data.data && res.data.data.isGuestCheckoutEnabled === true;
    } catch (e) {
      this.guestCheckoutEnabled = false;
    }
    if (!this.guestCheckoutEnabled) {
      this.$router.replace('/login');
    }
  },
  methods: {
    ...mapMutations({
      updatePaySelectAddress: "user/updatePaySelectAddress",
      updateCheckProductPay: "cart/updateCheckProductPay",
      updateCartItems: "cart/updateCartItems",
    }),
    ...mapActions({
      requestAddressList: "user/requestAddressList",
      requestOrderPay: "order/requestOrderPay",
      setSafewordFunc: "order/setSafewordFunc",
      requestOrderSubmit: "order/requestOrderSubmit",
    }),
    changeShowModel(e) {
      this.showModel = e;
    },
    async onGuestSuccess() {
      const guestItems = getGuestCart();
      if (guestItems && guestItems.length > 0) {
        for (const item of guestItems) {
          try {
            const res = await cartAdd({
              skuId: item.skuId,
              quantity: item.quantity,
            });
            if (res && res.data && res.data.data && res.data.data.currentCart) {
              this.$store.commit('SETCURRENTCART', res.data.data.currentCart);
            }
          } catch (e) {
            console.warn('Sync guest cart item failed:', item.skuId, e);
          }
        }
        clearGuestCart();
      }
      this.$nextTick(() => {
        this.checkout_init();
      });
    },
    onGuestNeedLogin({ username }) {
      this.$router.push({ path: '/login', query: { redirect: '/settlement', email: username } });
    },
    priceFmt(num) {
      return formatCurrency(num, { estimate: true });
    },
    showAddAddressView(bool) {
      this.addAddressView = !this.addAddressView;
    },
    applySelectedAddress(item) {
      if (!item || !item.id) {
        return;
      }
      const regionName =
        item.regionName ||
        [item.country, item.province, item.city].filter(Boolean).join(" ").trim();
      this.defaultAddress = {
        ...item,
        consignee: item.consignee || item.contacts,
        regionName,
      };
      const addressChanged = this.formData.addressId !== item.id;
      this.formData.addressId = item.id;
      if (addressChanged) {
        this.checkout_calculate();
      }
    },
    onAddressSaved() {
      return this.requestAddressList().then(() => {
        const def = this.$store.getters["user/defaultAddress"];
        if (def && def.id) {
          this.updatePaySelectAddress(def);
          this.applySelectedAddress(def);
        }
      });
    },
    getChcekData() {
      let data = [];
      this.checkProductPay.forEach((item) => {
        data = [
          ...data,
          ...item.list.filter(
            (listItem) => item.checkList.indexOf(listItem.Identifier) > -1
          ),
        ];
      });
      this.chcekData = data;
      this.checkNum = data.length;
      return data;
    },
    async pay() {
      // if (!this.paySelectAddress?.id) {
      //   return this.$message.error(
      //     this.$t("message.home.ShippingAddressNotSet" /* 未设置收货地址 */)
      //   );
      // }

      // const checkData = this.getChcekData();
      // // const ids = checkData.map((item) => item.id)

      // checkData.map((item) => [item.id, item.checkTotal]).join(",");

      // const orderInfo = checkData
      //   .map((item) => [item.id, item.skuid || -1, item.checkTotal])
      //   .join(",");
      // if (!orderInfo) {
      //   return this.$message.error(
      //     this.$t("message.home.NoProductSelected" /* 请选择商品 */)
      //   );
      // }
      // const addressId = this.paySelectAddress.id;
      // if (
      //   !(
      //     this.lastSubmit.orderIds &&
      //     this.lastSubmit.addressId == addressId &&
      //     this.lastSubmit.orderInfo == orderInfo
      //   )
      // ) {
      //   const result = await this.requestOrderSubmit({
      //     orderInfo: orderInfo,
      //     addressId: addressId,
      //   });
      //   this.currentSubmitOrderIds = result.orderList.map(
      //     (item) => item.orderId
      //   );
      //   localStorage.setItem(
      //     "currentSubmitOrderIds",
      //     this.currentSubmitOrderIds
      //   );
      //   this.lastSubmit = {
      //     orderInfo,
      //     orderIds: this.currentSubmitOrderIds,
      //     addressId,
      //   };
      // } else {
      // }
      // if (!this.userInfo.safeword) {
      //   // 设置支付密码
      //   this.payModalShow = true;
      //   this.showModel = 1;
      //   return;
      // }
      // if (!this.checkoutAmount()) {
      //   return;
      // }
      // this.payModalShow = true;
      this.$router.replace("/paySuccess");
    },
    cleartCheckData(ids) {
      this.checkProductPay.forEach((item) => {
        item.list = item.list.filter((listItem) => !ids.includes(listItem.id));
      });
      this.updateCheckProductPay(
        this.checkProductPay.filter((item) => !!item.list.length)
      );
    },
    selectAddressEvent() {
      this.addAddressModalShow = true;
    },
    async payCallback(password, successCallBack, failCallBack) {
      if (!this.checkoutAmount()) {
        return;
      }
      if (!this.currentSubmitOrderIds.length) {
        this.currentSubmitOrderIds = localStorage.getItem(
          "currentSubmitOrderIds"
        );
      }
      await this.requestOrderPay({
        orderId: this.currentSubmitOrderIds.join(","),
        safeword: password,
      })
        .then(() => {
          // let cartItemsData = getCartItemsLocal();
          const cartItemsData = getCartItemsLocal().then(result => {
            return result;
          });
          const checkData = this.getChcekData();
          if (cartItemsData && cartItemsData.length) {
            const checkIds = checkData.map((item) => item.attrTime);
            cartItemsData = cartItemsData.filter(
              (item) => !checkIds.includes(item.attrTime)
            );
            // 支付成功后，清除购物车中的订单
            this.getCartItemsLocal(cartItemsData);
          }
          const list = []
          this.updateCartItems(list)
          successCallBack && successCallBack();
          this.$router.replace("/paySuccess");
        })
        .catch(() => {
          failCallBack && failCallBack();
        })
        .finally(() => {
          localStorage.removeItem("currentSubmitOrderIds");
          this.payModalShow = false;
        });
    },
    checkoutAmount() {
      if (this.isDisabledPayBtn) {
        if (this.checkTotalAmount.at(0) == "0") {
          this.$message({
            message: this.$t(
              "message.home.NoProductSelected" /**还未选择商品 */
            ),
            type: "error",
          });
        } else {
          this.$message({
            message: this.$t("message.home.balanceNot" /**余额不足，请充值 */),
            type: "error",
          });
        }
        this.payModalShow = false;
        return false;
      }
      return true;
    },


    // changeAddressView(){
    //   this.$emit('showAddAddressView')
    // },

    // selectAddress(item) {
    //   this.updatePaySelectAddress(item)
    //   this.dialogVisible = false
    // },



    ////////////////////////////////////////////////methods//////////////////////////////////////////////////

    async checkout_init() {
      if (this.$route.query.skuId) {
        this.skuId = this.$route.query.skuId ? this.$route.query.skuId : null;
        this.formData.skuId = this.skuId ? this.skuId : null;
        this.marketingId = this.$route.query.marketingId ? this.$route.query.marketingId : null;
        this.formData.marketingId = this.marketingId ? this.marketingId : null;
        this.notJoinGroup = this.$route.query.notJoinGroup ? true : false;
        this.formData.notJoinGroup = this.$route.query.notJoinGroup ? true : false;
        this.skuQuantity = this.$route.query.quantity ? this.$route.query.quantity : null;
        this.formData.quantity = this.skuQuantity ? this.skuQuantity : null;
        this.orderType = this.$route.query.orderType ? this.$route.query.orderType : null;
      } else if (this.$route.query.goodsId && !this.$route.query.skuId) {
        await this.resolveExchangeSkuFromGoodsId(String(this.$route.query.goodsId));
      }
      if (this.currentCart) {
        this.formData.currentCartId = this.currentCart.id;
      }
      if (this.skuId) {
        this.checkout(this.skuId, this.marketingId, this.skuQuantity);
      } else {
        if (!this.currentCart || !this.currentCart.id) {
          this.$message.error(this.$t("message.home.NoProductSelected") || "请先选择商品或从商品页立即购买进入结算");
          this.loading = false;
          return;
        }
        this.checkout(null, null, null);
      }
    },
    /** 积分兑换等场景只传 goodsId 时，从兑换列表解析默认 SKU */
    async resolveExchangeSkuFromGoodsId(goodsId) {
      try {
        const r = await exchange_list({ pageNumber: 1, pageSize: 200 });
        const data = r.data?.data;
        const arr = Array.isArray(data) ? data : (data?.content || []);
        const item = arr.find((it) => it.goods && String(it.goods.id) === String(goodsId));
        if (item && item.id) {
          this.skuId = item.id;
          this.formData.skuId = item.id;
          const q = this.$route.query.quantity != null ? Number(this.$route.query.quantity) : 1;
          this.skuQuantity = Number.isFinite(q) && q > 0 ? q : 1;
          this.formData.quantity = this.skuQuantity;
          this.marketingId = this.$route.query.marketingId || null;
          this.formData.marketingId = this.marketingId;
          this.orderType = this.$route.query.type || this.$route.query.orderType || null;
        }
      } catch (e) {
        console.error(e);
      }
    },
    bindPaymentPatternsChange: function (e) {
      this.indexPM = e.detail.value;
      if (this.paymentPatterns && 0 < this.paymentPatterns.length) {
        this.formData.paymentPatternId = this.paymentPatterns[this.indexPM].id;
      }
      if (!e.detail.isLoad) {
        this.checkout_calculate();
      }

    },
    bindShippingMethodsChange: function (e) {
      this.indexSM = e.detail.value;
      if (this.shippingMethods && 0 < this.shippingMethods.length) {
        this.formData.shippingMethodId = this.shippingMethods[this.indexSM].id;
      }
      if (!e.detail.isLoad) {
        this.checkout_calculate();
      }
    },
    bindCouponsChange: function (e) {
      this.indexCC = e.detail.value;
      if (this.coupons && 0 < this.coupons.length) {
        this.formData.code = this.coupons[this.indexCC].code;
      }
      if (!e.detail.isLoad) {
        this.checkout_calculate();
      }
    },

    parseAmount(val) {
      const n = Number(val);
      return Number.isFinite(n) ? n : 0;
    },
    getOrderAmountBeforeDeposit() {
      const o = this.obj || {};
      const amount = this.parseAmount(o.amount);
      if (amount > 0) {
        return amount;
      }
      return this.parseAmount(o.amountPayable) + this.parseAmount(this.formData.balance);
    },
    setAvailableBalanceFromCheckout(data) {
      if (data && data.availableBalance != null) {
        this.availableBalance = data.availableBalance;
      }
    },
    onDepositToggle(enabled) {
      if (enabled) {
        this.applyMaxDeposit();
      } else {
        this.formData.balance = 0;
        this.balanceInput = 0;
        this.checkout_calculate();
      }
    },
    applyMaxDeposit() {
      const max = this.maxDepositAmount;
      this.balanceInput = max;
      this.formData.balance = max;
      this.useDepositBalance = max > 0;
      if (max > 0) {
        this.checkout_calculate();
      }
    },
    onBalanceChange(val) {
      let b = this.parseAmount(val);
      const max = this.maxDepositAmount;
      if (b > max) {
        b = max;
      }
      if (b < 0) {
        b = 0;
      }
      this.balanceInput = b;
      this.formData.balance = b;
      this.useDepositBalance = b > 0;
      this.checkout_calculate();
    },
    isOrderFullyPaidByDeposit(orders) {
      if (!orders || !orders.length) {
        return false;
      }
      const payable = orders.reduce((s, o) => {
        // create 接口返回的订单不含 amountPayable 字段，缺失时用 amount - amountPaid - refundAmount 兜底计算真实应付额
        const p = o.amountPayable != null
          ? this.parseAmount(o.amountPayable)
          : this.parseAmount(o.amount) - this.parseAmount(o.amountPaid) - this.parseAmount(o.refundAmount);
        return s + p;
      }, 0);
      return payable <= 0;
    },
    handleCheckoutApiError(err) {
      const raw = (err && err.response && err.response.data && err.response.data.message) || "";
      const i18nKey = raw ? "message.home." + raw : "";
      let text = "";
      if (raw && this.$te(i18nKey)) {
        text = this.$t(i18nKey);
      } else if (raw) {
        text = raw;
      } else {
        text = this.$t("message.home.checkoutLoadFailed");
      }
      if (raw === "shop_order_selectOrAddAddress") {
        this.$confirm(text, this.$t("message.home.checkoutErrorTitle"), {
          confirmButtonText: this.$t("message.home.goAddAddress"),
          cancelButtonText: this.$t("message.home.close"),
          type: "warning",
        })
          .then(() => {
            this.$router.push("/userInfo/setup/shipping-address");
          })
          .catch(() => {});
      } else {
        this.$message.error(text);
      }
    },

    checkout: function (skuId, marketingId, skuQuantity) {
      this.loading = true;
      //直接购买
      if (skuId) {
        checkout({
          "skuId": skuId ? skuId : null,
          "marketingId": marketingId ? marketingId : null,
          "notJoinGroup": this.notJoinGroup,
          "quantity": skuQuantity != null ? Number(skuQuantity) : 1
        }).then(response => {
          this.loading = false;
          //下拉加载
          this.obj = response.data.data;
          this.setAvailableBalanceFromCheckout(response.data.data);
          this.objsList = response.data.data.cartItems;
          this.paymentPatterns = response.data.data.paymentPatterns;
          this.shippingMethods = response.data.data.shippingMethods;
          this.coupons = response.data.data.coupons;
          let event = {
            'detail': {
              'value': 0,
              "isLoad": true
            }
          };
          this.bindCouponsChange(event);
          this.bindPaymentPatternsChange(event);
          this.bindShippingMethodsChange(event);
          this.defaultAddress = response.data.data.defaultAddress;
          this.formData.addressId = this.defaultAddress && this.defaultAddress.id ? this.defaultAddress.id : null;
          if (this.defaultAddress && this.defaultAddress.id) {
            this.updatePaySelectAddress(this.defaultAddress);
          }
          // checkout 接口已用默认地址/默认运费方式算好了价格，无需再调一次 calculate 重复计算
        }).catch((err) => {
          this.loading = false;
          this.handleCheckoutApiError(err);
        });
      } else {
        //购物车提交
        if (!this.currentCart || !this.currentCart.id) {
          this.loading = false;
          return;
        }
        checkout({
          "currentCartId": this.currentCart.id
        }).then(response => {
          this.loading = false;
          this.obj = response.data.data;
          this.setAvailableBalanceFromCheckout(response.data.data);
          this.objsList = response.data.data.cartItems;
          this.paymentPatterns = response.data.data.paymentPatterns;
          this.shippingMethods = response.data.data.shippingMethods;
          this.defaultAddress = response.data.data.defaultAddress;
          this.formData.addressId = this.defaultAddress && this.defaultAddress.id ? this.defaultAddress.id : null;
          if (this.defaultAddress && this.defaultAddress.id) {
            this.updatePaySelectAddress(this.defaultAddress);
          }
          this.coupons = response.data.data.coupons;
          let event = {
            'detail': {
              'value': 0,
              "isLoad": true
            }
          };
          this.bindCouponsChange(event);
          this.bindPaymentPatternsChange(event);
          this.bindShippingMethodsChange(event);
          // checkout 接口已用默认地址/默认运费方式算好了价格，无需再调一次 calculate 重复计算
        }).catch((err) => {
          this.loading = false;
          this.handleCheckoutApiError(err);
        });
      }

    },

    // 积分抵现：输入变化重新计算
    onUsePointChange() {
      if (!this.formData.usePoint || this.formData.usePoint < 0) {
        this.formData.usePoint = 0;
      }
      this.checkout_calculate();
    },

    // 计算
    checkout_calculate() {
      if (!this.formData.addressId) {
        return;
      }
      this.loading = true;
      calculate(this.formData).then(response => {
        this.loading = false;
        const d = response.data.data || {};
        const keys = ['amount', 'amountPayable', 'couponDiscount', 'exchangePoint', 'fee',
          'freight', 'isDelivery', 'price', 'marketingDiscount', 'rewardPoint', 'tax', 'deductionAmount'];
        keys.forEach(k => {
          if (d[k] !== undefined && d[k] !== null) {
            this.$set(this.obj, k, d[k]);
          }
        });
        if (d.amountPayable !== undefined && d.amountPayable !== null) {
          this.totalPrice = d.amountPayable;
        }
      }).catch((err) => {
        this.loading = false;
        this.handleCheckoutApiError(err);
      })
    },


    formSubmit: function (e) {
      this.loading = true;
      if (!this.formData.addressId) {
        this.loading = false;
        this.$message({
            message: "请填选收货地址",
            type: "error",
        });
        return;
      }
      create(this.formData).then(response => {
        //购物车订单提交成功要，根据是否选中，清理购物车前台session缓存
        this.orders = response.data.data.orders;
        this.orderSns = response.data.data.orderSns;
        if (this.orders) {
          if (this.isOrderFullyPaidByDeposit(this.orders)) {
            this.loading = false;
            this.$router.replace("/paySuccess");
            return;
          }
          this.payment_payment().then(() => {
            // 根据支付方式分支处理（label 与后端 biz_payment_config.mode_id 对齐）
            switch (this.paymentMethodRadio) {
              case 'paypalPayment':
                this.payment_paypalPay();
                break;
              case 'stripePayment':
                this.payment_stripePay();
                break;
              default:
                // Biz System 默认支付
                this.payModalShow = true;
            }
          });
        } else {
          this.loading = false;
        }
      }).catch((err) => {
        this.loading = false;
        this.handleCheckoutApiError(err);
      })
    },
    guanbi: function () {
      var that = this;
      that.showcartlist = false;
      that.invoiceShow = false;
    },
    showgaozhishu: function () {
      var that = this;
      that.invoiceShow = true;
    },

    // checkout_payment: function () {
    //   this.orderSns = options.orderSns;
    //   this.payment_payment();
    // },

    payment_payment: function () {
      return payment(this.orderSns).then(response => {
        this.loading = false;
        this.totalPrice = response.data.data.amount;
        this.orders = response.data.data.orders;
        this.orderSns = response.data.data.orderSns;
        this.online = response.data.data.online;
        this.defaultPayment = response.data.data.defaultPayment;
        this.payments = response.data.data.payments;
        this.shippingMethodName = response.data.data.shippingMethodName;
        this.paymentPatternName = response.data.data.paymentPatternName;
        this.paymentPattern = response.data.data.paymentPattern;
        this.expireDate = response.data.data.expireDate;
        this.paymentItemListForm.paymentItemList = [];
        let paymentItem = {};
        for (let i = 0; i < this.orders.length; i++) {
          paymentItem = {};
          paymentItem.type = "ORDER_PAYMENT";
          paymentItem.amount = this.orders[i].amountPayable != null ? this.orders[i].amountPayable : this.orders[i].amount;
          paymentItem.orderSn = this.orders[i].sn;
          this.paymentItemListForm.paymentItemList.push(paymentItem);
        }
      }).catch(error => {
        this.loading = false;
        console.error("error", error);
      })
    },

    payment_outLinePay: function () {
      load(
        this.paymentItemListForm, {
        "paymentId": this.defaultPayment.id,
        "rePayUrl": "test"
      }).then(response => {
        this.loading = false;
        this.paymentLog = response.data.data.paymentLog;
        this.payment_testpostpay();
      }).catch(error => {
        // 关闭loading
        console.error("error", error);
        // /弹出未知错误
      })
    },

    payment_testpostpay: function () {
      const paymentLogSn = this.paymentLog && this.paymentLog.sn;
      if (!paymentLogSn) {
        this.$message.error(this.$t('message.home.paymentFailed') || 'Payment failed');
        return;
      }
      testPostPay({
        "extra": "Order pay",
      }, paymentLogSn).then(response => {
        const isPaySuccess = response && response.data && response.data.data && response.data.data.isPaySuccess;
        if (isPaySuccess === false) {
          this.$message.error(this.$t('message.home.paymentFailed') || 'Payment failed');
          return;
        }
        return is_pay_success({ paymentLogSn }).then((verifyRes) => {
          const confirmed = verifyRes && verifyRes.data && verifyRes.data.data && verifyRes.data.data.isPaySuccess;
          if (!confirmed) {
            this.$message.error(this.$t('message.home.paymentFailed') || 'Payment failed');
            return;
          }
          this.payModalShow = false;
          this.$router.replace({ path: '/paySuccess', query: { paymentLogSn } });
        });
      }).catch(error => {
        console.error("error", error);
        this.$message.error(this.$t('message.home.paymentFailed') || 'Payment failed');
      })
    },

    // ============================= PayPal 支付 =============================

    loadPaypalSDK: function (clientId, currency) {
      return new Promise((resolve, reject) => {
        const cur = currency || 'USD';
        if (this.paypalSDKLoaded && this.paypalSDKCurrency === cur) {
          resolve();
          return;
        }
        const script = document.createElement('script');
        script.src = 'https://www.paypal.com/sdk/js?client-id=' + encodeURIComponent(clientId) + '&currency=' + encodeURIComponent(cur);
        script.onload = () => {
          this.paypalSDKLoaded = true;
          this.paypalSDKCurrency = cur;
          resolve();
        };
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },

    payment_paypalPay: function () {
      paymentIndex(this.paymentItemListForm, {
        "paymentId": "paypalPayment",
        "rePayUrl": "payment"
      }).then(response => {
        this.paymentLog = response.data.data.paymentLog;
        return paymentPay({
          "extra": "Order pay",
          "paymentLogSn": this.paymentLog.sn
        });
      }).then(response => {
        const resultAmount = response.data.data.resultAmount;
        const resultOrderId = response.data.data.resultOrderId;
        const clientId = response.data.data.clientId;
        const currency = response.data.data.currency || 'USD';
        const paymentLogSn = this.paymentLog.sn;
        const self = this;

        this.paypalDialogVisible = true;
        this.loading = false;

        this.loadPaypalSDK(clientId, currency).then(() => {
          this.$nextTick(() => {
            const ppContainer = document.getElementById('paypal-button-container');
            const cardContainer = document.getElementById('paypal-card-button-container');
            if (ppContainer) ppContainer.innerHTML = '';
            if (cardContainer) cardContainer.innerHTML = '';

            const buttonConfig = {
              createOrder: function (data, actions) {
                return actions.order.create({
                  purchase_units: [{
                    reference_id: resultOrderId,
                    amount: { value: String(resultAmount), currency_code: currency }
                  }],
                  application_context: {
                    shipping_preference: 'NO_SHIPPING',
                    user_action: 'PAY_NOW'
                  }
                });
              },
              onApprove: function (data, actions) {
                return actions.order.capture().then(function () {
                  postPay({ "extra": "Order pay" }, paymentLogSn).then(() => {
                    self.paypalDialogVisible = false;
                    self.$router.replace("/paySuccess");
                  }).catch(() => {
                    self.paypalDialogVisible = false;
                    self.$router.replace("/paySuccess");
                  });
                });
              },
              onCancel: function () {
                self.$message({ message: 'PayPal payment cancelled', type: 'warning' });
              },
              onError: function (err) {
                console.error('PayPal error:', err);
                self.$message({ message: 'PayPal payment failed', type: 'error' });
              }
            };

            // PayPal 黄色按钮 - 弹窗登录支付
            window.paypal.Buttons({
              fundingSource: window.paypal.FUNDING.PAYPAL,
              style: { layout: 'horizontal', color: 'gold', shape: 'rect', label: 'paypal', tagline: false },
              ...buttonConfig
            }).render('#paypal-button-container');

            // 信用卡/借记卡按钮 - 独立 fundingSource 强制弹窗(非内联)
            try {
              const cardBtns = window.paypal.Buttons({
                fundingSource: window.paypal.FUNDING.CARD,
                style: { layout: 'horizontal', color: 'black', shape: 'rect', label: 'pay', tagline: false },
                ...buttonConfig
              });
              if (cardBtns.isEligible()) {
                cardBtns.render('#paypal-card-button-container');
              }
            } catch (e) {
              console.warn('PayPal card button not eligible:', e);
            }
            self.paypalButtonsRendered = true;
          });
        });
      }).catch(error => {
        this.loading = false;
        console.error("PayPal payment error:", error);
        this.$message({ message: 'PayPal payment initialization failed', type: 'error' });
      });
    },

    onPaypalDialogClose: function () {
      const ppContainer = document.getElementById('paypal-button-container');
      const cardContainer = document.getElementById('paypal-card-button-container');
      if (ppContainer) ppContainer.innerHTML = '';
      if (cardContainer) cardContainer.innerHTML = '';
      this.paypalButtonsRendered = false;
    },

    // ============================= Stripe 支付 =============================

    loadStripeJS: function () {
      return new Promise((resolve, reject) => {
        if (window.Stripe) {
          resolve();
          return;
        }
        const script = document.createElement('script');
        script.src = 'https://js.stripe.com/v3/';
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },

    payment_stripePay: function () {
      paymentIndex(this.paymentItemListForm, {
        "paymentId": "stripePayment",
        "rePayUrl": "payment"
      }).then(response => {
        this.paymentLog = response.data.data.paymentLog;
        return paymentPay({
          "extra": "Order pay",
          "paymentLogSn": this.paymentLog.sn
        });
      }).then(response => {
        const clientSecret = response.data.data.clientSecret;
        const publishableKey = response.data.data.publishableKey;
        this.stripePaymentLogSn = this.paymentLog.sn;

        this.loadStripeJS().then(() => {
          this.stripeInstance = window.Stripe(publishableKey);
          this.stripeElements = this.stripeInstance.elements({
            clientSecret: clientSecret,
          });
          const paymentElement = this.stripeElements.create('payment');
          paymentElement.mount('#stripe-payment-element');
          paymentElement.on('ready', () => {
            this.stripeReady = true;
            this.loading = false;
          });
        });
      }).catch(error => {
        this.loading = false;
        console.error("Stripe payment error:", error);
        this.$message({ message: 'Stripe payment initialization failed', type: 'error' });
      });
    },

    handleStripePay: function () {
      if (!this.stripeInstance || !this.stripeElements) return;
      this.stripeLoading = true;
      const returnUrl = window.location.origin + '/#/paySuccess?paymentLogSn=' + this.stripePaymentLogSn;
      this.stripeInstance.confirmPayment({
        elements: this.stripeElements,
        confirmParams: {
          return_url: returnUrl,
        },
      }).then(result => {
        if (result.error) {
          this.stripeLoading = false;
          this.$message({ message: result.error.message, type: 'error' });
        }
        // 成功时 Stripe 会自动重定向到 return_url
      });
    },

    //////////////////////////////////////////////////////////////////////////////////////////////////

  },
};
</script>

<style lang="scss">
.settlement {
  &-content {
    .title {
      font-weight: 600;
      font-size: 24px;
      color: var(--color-title);
      margin-bottom: 12px;
    }

    .subtitle {
      font-weight: 600;
      font-size: 20px;
      color: var(--color-title);
      margin-bottom: 15px;
    }
  }

  &-receiver {
    border: 1px solid var(--color-border);
    padding: 16px 20px;
    border-radius: 4px;
    margin-bottom: 12px;
    cursor: pointer;

    .userinfo {
      font-weight: 500;
      font-size: 12px;
      color: var(--color-title);
      margin-bottom: 5px;
    }

    .address {
      display: inline-block;
      font-weight: 500;
      max-width: 1000px !important;
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap; //溢出不换行
      font-size: 12px;
      color: var(--color-subtitle);
    }

    div:first-child {
      flex: 1;
    }

    div:last-child {
      width: 50px;
      text-align: right;
    }
  }

  &-pay {
    border: 1px solid var(--color-border);
    padding: 11px 20px;
    margin: 40px 0;

    &-label {
      font-weight: 500;
      font-size: 12px;
      color: var(--color-title);

      span {
        color: var(--color-main);
      }
    }

    .el-button {
      font-weight: 700;
      font-size: 14px;
      color: var(--color-white);

      span:first-child {
        margin-right: 10px;
      }
    }
  }
}

/////////////////////////////////////////////////////////////////////////////////////////////
html[dir="rtl"] {
  .settlement {
    .settlement-commodity-wrap .el-input-number {
      left: 24px;
      right: auto;
    }

    .settlement-commodity-item img {
      // margin-right: 5px;
      margin-left: 18px;
    }

    .el-checkbox__label {
      padding-right: 10px;
      padding-left: 0;
    }
  }
}

.settlement {
  .settlement-commodity-info-attr {
    color: #666;
    padding-top: 4px;
    font-size: 12px;
  }

  &-commodity {
    padding-bottom: 20px;

    &-title {
      margin-bottom: 11px;
      margin-top: 18px;

      .el-checkbox__label {
        font-weight: 500;
        font-size: 12px;
        color: var(--color-title);
      }
    }

    &-wrap {
      position: relative;

      .el-input-number {
        width: 100px;
        position: absolute;
        top: 30px;
        right: 24px;
      }

      .el-input-number__decrease,
      .el-input-number__increase {
        background-color: var(--color-white);
      }
    }

    &-wrap:first-child {
      .el-checkbox {
        border-top: 0;
      }
    }

    &-group {
      border: 1px solid var(--color-border);
      border-radius: 4px;
      padding: 10px;
    }

    &-item {
      img {
        width: 62px;
        height: 62px;
        margin-right: 18px;
        object-fit: contain;
      }
    }

    &-info {
      flex: 1;

      div {
        width: 100%;
      }

      h2 {
        font-weight: 400;
        font-size: 14px;
        color: var(--color-black);
        margin-bottom: 10px;
        max-width: 800px !important;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      p {
        font-weight: 500;
        font-size: 16px;
        color: var(--color-price);
      }
    }

    &-checkbox {
      display: flex !important;
      padding: 20px 10px;
      border-top: 1px solid var(--color-border);

      .el-checkbox__label {
        flex: 1;
      }
    }

    .el-checkbox__inner {
      border-radius: 50%;
    }
  }
}



////////////////////////////////////////////////////////////////////////////////////////////

.order-sum {
  margin-bottom: 20px;

  h1 {
    font-weight: 600;
    font-size: 24px;
    color: var(--color-title);
    margin: 18px 0;
  }

  &-content {
    background-color: var(--color-little-grey);
    padding: 0 28px;
    border-radius: 4px;

    li {
      font-weight: 600;
      font-size: 14px;
      padding: 15px 0;

      span:first-child {
        color: var(--color-subtitle);
      }

      span:last-child {
        color: var(--color-black);
      }
    }

    .total {
      border-top: 1px solid var(--color-border);

      span {
        color: var(--color-price) !important;
      }
    }
  }
}

///////////////////////////////////////////////////////////////////////////////////////////

.item {
  width: 100%;
  border: 1px solid var(--color-border);
  padding: 12px 16px;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 20px;

  &:hover {
    border-color: var(--color-main);
  }

  .info {
    margin-bottom: 8px;
  }
}

.address-active {
  border-color: var(--color-main);
}

////////////////////////////////////////////////////////////////////////////////////////////


html[dir="rtl"] {
  .pay-method-item-left .name {
    margin-right: 5px;
  }
}

.pay-method {
  h1 {
    font-weight: 600;
    font-size: 24px;
    color: var(--color-title);
    margin: 18px 0;
  }

  &-content {
    background: linear-gradient(0deg, #fff7ec, #fff7ec), #eeeeee;
    border-radius: 4px;
    padding: 0 28px;
  }

  &-item {
    padding: 15px 0;

    &-left {
      img {
        width: 20px;
      }

      .name {
        min-width: 200px;
        margin-left: 5px;

        span:first-child {
          font-weight: 600;
          font-size: 14px;
          color: var(--color-black);
        }
      }

      .amount {
        color: var(--color-price);
        font-weight: 600;
      }

      .not-bind {
        color: var(--color-subtitle);
        font-weight: 600;
      }

      .tips {
        color: var(--color-subtitle);
        font-weight: 400;

        i {
          color: var(--color-main);
        }
      }
    }

    .el-radio__label {
      display: none;
    }

    .el-radio__inner {
      background-color: #d9d9d9;
    }
  }

  &.deposit-pay {
    .deposit-input-row {
      flex-wrap: wrap;
    }

    .deposit-label {
      margin-right: 12px;
      font-size: 14px;
      color: var(--color-subtitle);
    }

    .deposit-max-btn {
      margin-left: 12px;
    }
  }
}
</style>
